import { API } from "aws-amplify"

const apiName = "api-extranet-scrb"
const baseUrl = "/scrb"

export const getInstallations = async (structureId, installationId, filtered) => {
    const structId = Number(structureId);
    const installations = await API.get(apiName, `${baseUrl}/installations/${structId}`, {
        queryStringParameters: {
            installationId: installationId,
            filtered: filtered
        }
    }).then(
        installations => {
            const result = JSON.parse(JSON.stringify(installations.body))
            return result;
        }).catch(err => { console.log(err) });
    return installations;
}

export const getCoffrets = async (structureId) => {
    const structId = Number(structureId);
    const coffrets = await API.get(apiName, `${baseUrl}/coffrets/${structId}`).then(
        coffrets => {
            return coffrets.body;
        }).catch(err => { console.log(err) });
    return coffrets;
}

export const createInstallation = async (installation) => {
    await API.post(apiName, `${baseUrl}/installations`, { body: installation }).then(
        installation => {
            return installation.body;
        }).catch(err => {
            console.log(err);
            throw err;
        });
};

export const updateTournee = async (tournee) => {
    try {
        const response = await API.post(apiName, `${baseUrl}/tournees`, { body: tournee });
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const getScrbData = async () => {
    const data = await API.get(apiName, `${baseUrl}/data`).then(
        data => { return data; }).catch(err => { console.log(err) });
    return data;
}

export const getCountries = async () => {
    const countries = await API.get(apiName, `${baseUrl}/countries`).then(
        countries => { return countries }).catch(err => { console.log(err) });
    return countries;
}

export const getInformations = async (informationId) => {
    const informations = await API.get(apiName, `${baseUrl}/informations/${informationId}`).then(
        informations => { return informations.body }).catch(err => { console.log(err) });
    return informations;
}

export const getReglements = async () => {
    const reglements = await API.get(apiName, `${baseUrl}/reglements`).then(
        reglements => { return reglements }).catch(err => { console.log(err) });
    return reglements;
}

export const downloadReglement = async (key) => {
    const file = await API.get(apiName, `${baseUrl}/reglement/${key}`).then(
        reglement => { window.open(reglement.headers.Location, '_blank') }).catch(err => { console.log(err) });
    return file;
}

export const getOutils = async () => {
    const outils = await API.get(apiName, `${baseUrl}/outils`).then(
        outils => { return outils }).catch(err => { console.log(err) });
    return outils;
}

export const downloadOutil = async (key) => {
    const file = await API.get(apiName, `${baseUrl}/outil/${key}`).then(
        file => { return file }).catch(err => { console.log(err) });
    return file;
}

export const getMailingTarget = async (structureId) => {
    const mailingTarget = await API.get(apiName, `${baseUrl}/mailing-target/${structureId}`).then(
        mailingTarget => { return mailingTarget.body }).catch(err => { console.log(err) });
    return mailingTarget;
}

export const saveMailingTarget = async (mailingTarget) => {
    try {
        const response = await API.post(apiName, `${baseUrl}/mailing-target`, {
            body: mailingTarget
        });
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const deleteMailingTarget = async (target) => {
    try {
        const response = await API.del(apiName, `${baseUrl}/mailing-target`, { body: target });
        return response;
    } catch (err) {
        console.log(err);
        throw err;
    }
}
